// Englische Fassung von ../de/labels.ts. Nur Text — die Badge-Farbe bleibt in
// ui/labels.ts.
import type { LabelsKatalog } from "../de/labels";

export const labels: LabelsKatalog = {
  status: {
    // ---- Tasks / Kanban / timeline ----
    todo: "To do",
    open: "Open",
    new: "New",
    in_progress: "In progress",
    ongoing: "Ongoing",
    "on hold": "On hold",
    on_hold: "On hold",
    feedback: "Feedback",
    done: "Done",
    closed: "Closed",
    lost: "Lost",

    // ---- Claims ----
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",

    // ---- Datasets ----
    draft: "Draft",
    queued: "Queued",
    extracting: "Extracting …",
    ready: "Ready",
    error: "Error",
    failed: "Failed",

    // ---- Documents (embedding + summary) ----
    doc_ai_pending: "Waiting for Doc AI",
    processing: "Processing …",

    // ---- Blog pipeline ----
    researching: "Researching …",
    toc_building: "Outline …",
    toc_approved: "Outline approved",
    skeleton_building: "Structure …",
    generating: "Generating …",
    generated: "Generated",
    compliance_blocked: "Compliance blocked",
    reviewer_blocked: "Review needed",
    needs_human_review: "Manual review",
    publishing: "Publishing …",
    published: "Published",
    archived: "Archived",

    // ---- Presentations ----
    planning: "Planning …",
    planned: "Planned",
    rendered: "Rendered",

    // ---- HeyGen (script + video) ----
    claim_picking: "Claim selection …",
    scene_building: "Scenes …",
    exported: "Exported",
    completed: "Completed",

    // ---- Generic states ----
    running: "Running",
    active: "Active",
    success: "Successful",
    ok: "OK",
    cancelled: "Cancelled",
    canceled: "Cancelled",
  },

  statusDomain: {
    document: {
      done: "Processed",
      completed: "Processed",
      pending: "Pending",
    },
  },

  level: {
    easy: "Quick",
    medium: "Standard",
    hard: "Thorough",
    sophisticated: "Expert",
  },

  bildKlassifikation: {
    reuse_1to1: "Reuse 1:1",
    study_graphic: "Study graphic",
    inspiration_editorial: "Inspiration (editorial)",
    inspiration_infographic: "Inspiration (infographic)",
    decorative_skipped: "Decorative (skipped)",
    unclassified: "Unclassified",
    study_chart: "Study chart",
    mechanism_diagram: "Mechanism diagram",
    photo: "Photo",
    decorative: "Decorative",
  },

  bildRolle: {
    image_hero: "Hero image",
    image_inline: "Inline image",
    figure_embed: "Embedded figure",
    linkedin_hero: "LinkedIn hero",
  },

  // Produktname — bleibt in der englischen Oberfläche genau der Name, unter dem
  // das Projekt auch in der Datenbank steht (docs/i18n.md §3).
  projektMeineSops: "My SOPs",
};
